var exports = {
  "o5": "x8b4e8595--f80436--content-wrapper",
  "HE": "x8b4e8595--f80436--button-wrapper",
  "aw": "x8b4e8595--f80436--semi-transparent",
  "Sl": "x8b4e8595--f80436--image",
  "W4": "x8b4e8595--f80436--text-wrapper",
};

module.exports = exports;
